var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSelectAll24Line = function SvgIconSelectAll24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 16.85H9.8c-1.46 0-2.65-1.19-2.65-2.65V6.8c0-1.46 1.19-2.65 2.65-2.65h7.4c1.46 0 2.65 1.19 2.65 2.65v7.4c0 1.46-1.19 2.65-2.65 2.65Zm-7.4-11a.95.95 0 0 0-.95.95v7.4c0 .525.425.95.95.95h7.4a.95.95 0 0 0 .95-.95V6.8a.95.95 0 0 0-.95-.95H9.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.85H6.8c-1.46 0-2.65-1.19-2.65-2.65V8h1.7v9.2c0 .525.425.95.95.95H16v1.7ZM12.62 13.1h-.03a1.44 1.44 0 0 1-1.03-.46l-1.68-1.8 1.24-1.16 1.505 1.61L15.9 8.06l1.195 1.21-3.46 3.415c-.275.27-.635.42-1.02.42l.005-.005Z",
    fill: "current"
  })));
};
export default SvgIconSelectAll24Line;